export const releasedNodeTypes = [
  "HUB",
  "PLUG",
  "SWITCH",
  "TAG",
  "MOTION_DETECTOR",
  "PANIC_BUZZER",
  "DOUBLE_SWITCH",
  "PLUG_16",
  "SWITCH_DIMMER",
  "SSD_0",
  "SSS_0",
  "VIBRATION_TAG",
  "P_1",
  "S_1",
  "T_1",
  "MS_1",
  "PA_1",
  "SS_1",
  "P16_1",
  "SD_1",
  "SSD_1",
  "SSS_1",
  "ZMOTE",
  "IWS_MC_1",
  "IWS_YLC_1",
  "IWS_YLC_2",
  "IWS_GC_1",
  "IWS_16A_1",
  "SSS_2",
  "IWS_MC_2",
  "IWS_GC_2",
  "IWS_2RC_1",
  "IWS_RGB_1",
  "T_2",
  "IWS_3D_1",
  "IWS_SC_AC_1",
  "IR_1",
  "AQ_1",
  "IWS_3RC_1",
  "IWS_SC_DC_1",
  "IWS_1D_1",
  "IW_DOS_1",
  "YLM_1",
  "SS_2",
  "RPTR_1",
  "IWS_2D_1",
  "RESERVED_1",
  "IWS_3D_2",
  "EM_1",
  "LK_1",
  "VDP_1",
  "MBC_1",
  "TEMP_H_1",
  "ParamT_1",
  "FM_1",
  "MBC_2",
  "PULSE_EM",
  "IWS_TD_1",
  "DC_EP_1",
  "DLR_1",
  "GLD_1",
  "T_3",
  "IWS_3D_3",
  "IWS_SC_DC_2",
  "TR_EP_1",
  "SS_3",
  "IWS_16A_2",
  "IWS_MC_3",
  "IWS_SC_DC_21",
  "RPTR_2",
  "IWS_2RC_2",
  "IWS_2D_2",
  "SSS_3",
  "IWS_TD_2",
  "IWS_1D_2",
  "CC_LV_1",
  "IWS_TD_3",
  "YLM_2",
  "MS_2",
  "IWS_GC_3",
  "IWS_3RC_2",
  "GLD_2",
  "IWS_SC_AC_2",
  "TDLV_1",

  "TMSC",
  "E_85",
  "E_86",
  "E_87",
  "E_88",
  "E_89",
  "E_90",
  "E_91",
  "E_92",
  "E_93",
  "E_94",
  "E_95",
  "E_96",
  "E_97",
  "E_98",
  "E_99",

  "DS",
  "IWS_3D",
  "MSC",
  "TC",
  "IWS_2S",
  "IWS_16A",
  "CC",
  "SMLV",
  "RPTR",
  "IWS_2RC",
  "IWS_2D",
  "IWS_3S",
  "IWS_TD",
  "IWS_HPD",
  "CCLV",
  "YLM",
  "MS",
  "GC",
  "IWS_3RC",
  "LPGS",
  "DCSC",
  "IR",
  "RGBWW",
  "SWP_4S",
  "SWP_2D",
  "HUB_PRO",
  "HUB_PLUS",
  "DALI_SL",
  "DALI_SWP",
  "TDHV",
  "TRKD",
  "SC",
  "SC_ML",
  "VRFC",
  "WW",
  "MMC",
];
